import { useEffect, useState } from "react";
import { uniqueId } from "lodash";
import styles from './CategorySelection.module.scss';
import BtButton from "../../bt-button/bt-button";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ShowListCategory from './ShowListCategory';
import SingleCategorySelection from './SingleCategorySelection';
import { SelectorType } from "../../../components/shared/Selector/Selector";
import { useTranslation } from "react-i18next";

type SelectedCategory = {
  id: string,
  mainCategory: SelectorType & {subAreas: SelectorType[]} | null,
  subCategory: SelectorType | null,
};

type Props = {
  areas: (SelectorType & {subAreas: SelectorType[], _id: string})[],
  currentProjectAreas?: {areaId: { name: string, slug: string }}[],
  selectedCategories: SelectedCategory[],
  setSelectedCategories: (fn: (prevState: SelectedCategory[]) => SelectedCategory[]) => void,
  closeButtonText?: string,
  showList: boolean,
  setShowList: (value: boolean) => void,
}

const newArea = (): SelectedCategory => ({
  id: uniqueId(),
  mainCategory: null,
  subCategory: null,
});

const CategorySelection = ({ areas, currentProjectAreas = [], selectedCategories, setSelectedCategories, showList, setShowList }: Props) => {
  const [previouslySelectedCategories, setPreviouslySelectedCategories] = useState<SelectedCategory[]>([]);
  const [t] = useTranslation('projects', { keyPrefix: 'categorySelection' });

  useEffect(() => {
    if (selectedCategories.length === 0 && !showList) {
      setSelectedCategories(() => [newArea()]);
    }
  }, [selectedCategories, showList]);

  useEffect(() => {
    if (showList) {
      setPreviouslySelectedCategories(selectedCategories);
    }
  }, [showList]);

  if (showList) {
    return (
      <ShowListCategory
        areas={areas}
        currentProjectAreas={currentProjectAreas}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        previouslySelectedCategories={previouslySelectedCategories}
      />
    );
  }

  return (
    <div className={styles.container}>
      <SingleCategorySelection
        areas={areas}
        currentProjectAreas={currentProjectAreas}
        selectedCategories={selectedCategories}
        setSelectedCategories={setSelectedCategories}
        showList={showList}
      />
      <BtButton
        color="white"
        size="small"
        style={{ width: 'fit-content' }}
        leftIcon={<AddCircleIcon htmlColor="var(--orange-500)"/>}
        onClick={() => {
          setSelectedCategories(() => []);
          setShowList(true);
        }}
      >
        {t('button.add', 'Lägg till flera')}
      </BtButton>
    </div>
  )
};

export default CategorySelection;
